// branding image path using global branding service
import { Pipe, PipeTransform, inject } from '@angular/core';
import { GlobalBrandingService } from '@shared/services/global-branding.service';

export type BrandingImageFileNames =
  | 'house-residential.png'
  | 'two-story-house-gold.png'
  | 'stacked-coins-2.png'
  | 'remortgage-guide-step-1-icon.png'
  | 'remortgage-guide-step-2-icon.png'
  | 'remortgage-guide-step-3-icon.png'
  | 'dashboard-widget-poster-better-deal-expiring.jpg'
  | 'dashboard-widget-poster-calendar.jpg'
  | 'dashboard-widget-poster-present.jpg'
  | 'dashboard-widget-poster-door.jpg';

@Pipe({
  name: 'brandingAssetPath',
  standalone: true,
})
export class BrandingAssetPathPipe implements PipeTransform {
  private readonly globalBrandingService = inject(GlobalBrandingService);

  transform(imageFileName: BrandingImageFileNames): string {
    return this.globalBrandingService.getBrandingImageFolder() + imageFileName;
  }
}
